import React from 'react';

export interface PopoverTriggerProps {
  activated: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}
export interface PopoverProps {
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  onClose: () => void;
}
export interface PopoverState {
  triggerProps: PopoverTriggerProps;
  popoverProps: PopoverProps;
}
export const usePopoverState = (): PopoverState => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const isOpen = Boolean(anchorEl);

  const handleClick = ({ currentTarget }: React.MouseEvent<HTMLElement>) => {
    setAnchorEl((prev) => (prev ? null : currentTarget));
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return {
    triggerProps: {
      activated: isOpen,
      onClick: handleClick,
    },
    popoverProps: {
      anchorEl: anchorEl,
      isOpen: isOpen,
      onClose: handleClose,
    },
  };
};
